export const mapProductToCartItem = (
  product: Product
): Record<number, CartProduct> => {
  console.log(product);
  return {
    [product.id]: {
      category: product.child_name,
      name: product.name,
      price: product.sale_price,
      quantity: 1,
      productInfo: {
        image: product.image?.[0]?.filename || '',
        slug: product.linkname,
        category: product.child_name,
      },
      accessories: [],
    },
  };
};
